import Vue from 'vue'
import Vuex from 'vuex'
import settings from '../settings'

Vue.use(Vuex)

const DEFAULT_BASE_URL = '/api/qzc/laplace'

export default new Vuex.Store({
  state: {
    rightList: JSON.parse(sessionStorage.getItem('rightList') || '[]'),
    username: sessionStorage.getItem('username'),
    token: sessionStorage.getItem('token'),
    userId: sessionStorage.getItem('userId'),
    baseUrl: DEFAULT_BASE_URL,
    user: JSON.parse(sessionStorage.getItem('user')) || null,
    locale: settings.language || 'zh',
    isAdmin: sessionStorage.getItem('isAdmin') === 'true', // 是否为管理员
  },
  // mutations同步操作数据的方法
  mutations: {
    setUser(state, user) {
      state.user = user;
      sessionStorage.setItem('user', JSON.stringify(user)); // 对象需序列化
    },
    // 操作侧边栏数据
    setRightList(state, data) {
      state.rightList = data
      // 页面刷新时vuex中的数据会丢失，所以放入sessionStorage中
      // sessionStorage中是能放入字符串所以JSON.stringify()
      sessionStorage.setItem('rightList', JSON.stringify(data))
    },
    setUsername(state, data) {
      state.username = data
      sessionStorage.setItem('username', data)
    },
    setUserId(state, data) {
      state.userId = data
      sessionStorage.setItem('userId', data)
    },
    setToken(state, data) {
      state.token = data
      sessionStorage.setItem('token', data)
    },
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin
      sessionStorage.setItem('isAdmin', isAdmin.toString())
    },
  },
  // actions异步操作数据的方法
  actions: {

  },
  // getters类似于计算属性
  getters: {
    rightList: (state) => {
      return state.rightList;
    },
    locale: (state) => {
      return state.locale;
    }
  }
})
